import { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAppContext } from './AppContext';
import toast from 'react-hot-toast';
import { jobtypeprocess } from '../util/Jobtypeprocess';
import JSONIMG from '../Assets/json.png';
import CSVIMG from '../Assets/csv.png';

const JobContext = createContext();

export const JobProvider = ({ children }) => {
  const [formData, setFormData] = useState({ machinable: false,IMbarcode:true,unevenThickness:false });
  const [jsonData, setJsonData] = useState(null); // Store JSON string instead of FormData
  const [finalCSVs, setFinalCSVs] = useState({});
    const [company, setCompany] = useState({
       name: '',
       dba: '',
       address: '',
       address2: '',
       city: '',
       state: '',
       zip: '',
       industry: '',
       id:null
     });
  const [error, setError] = useState(null);
  const { user } = useAppContext();
  //const apiUrl = 'http://localhost:5003';
  const apiUrl = 'https://lightningpresort-3c0bfe3acad3.herokuapp.com'
  const nav = useNavigate();
console.log(company._id)
  // Log state changes for debugging
  useEffect(() => {
    console.log('jsonData:', jsonData);
    console.log('finalCSVs:', finalCSVs);
    console.log('error:', error);
  }, [jsonData, finalCSVs, error]);

  const getjson = async (formData, user) => {
    const jsonPayload = { ...formData, companyId: user, job_format: "Postcard" };
    console.log('FormData before submission:', jsonPayload);

    try {
      const response = await axios.post(`${apiUrl}/jobs/createjson`, jsonPayload, {
        headers: { 'Content-Type': 'application/json' },
      });
      const jsonString = JSON.stringify(response.data, null, 2);
      setJsonData(jsonString); // Store JSON string
    } catch (error) {
      console.error('Error in getjson:', error.response?.data || error.message);
      setError(error.response?.data?.error || error.message);
      toast.error('Failed to process data: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleConfirmedAction = () => {
    // toast.success('Action successfully executed!', {
    //   style: {
    //     background: '#ffffff',
    //     color: '#1f2937',
    //     border: '1px solid #e5e7eb',
    //     borderRadius: '8px',
    //     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    //   },
    //   iconTheme: {
    //     primary: '#4f46e5',
    //     secondary: '#ffffff',
    //   },
    // });

    checkeverything();
  };

  const sendum = async (count) => {
    const formDataToSend = new FormData();
    if (jsonData) {
      const blob = new Blob([jsonData], { type: 'application/json' });
      const jsonFile = new File([blob], 'user-data.json', { type: 'application/json' });
      formDataToSend.append('jsonFile', jsonFile);
      formDataToSend.append('recipient', 'summanusb@gmail.com,bryan@plsprint.com');
      formDataToSend.append('company','' || 'Unknown');
    }

    if (Object.keys(finalCSVs).length > 0) {
      Object.entries(finalCSVs).forEach(([fileName, csvData]) => {
        const csvBlob = new Blob([csvData], { type: 'text/csv' });
        const csvFile = new File([csvBlob], `${fileName}.csv`, { type: 'text/csv' });
        formDataToSend.append('csvFiles', csvFile);
        console.log(`CSV File added: ${fileName}.csv`);
      });
    }

    if (formDataToSend.has('jsonFile') && formDataToSend.has('csvFiles')) {
      // Removed: await sendjob(formDataToSend); // Delay sendjob until Save button
    } else {
      if (!formDataToSend.has('jsonFile')) {
        console.log('Waiting for JSON to be ready.');
        toast.error('JSON file is missing', {
          icon: <img src={JSONIMG} alt="JSON Icon" className="w-9 h-9" />,
          style: {
            borderRadius: '10px',
            background: 'yellow',
            color: 'black',
          },
        });
      }
      if (!formDataToSend.has('csvFiles')) {
        console.log('Waiting for CSV files to be ready.');
        toast.error('CSV file is missing', {
          icon: <img src={CSVIMG} alt="CSV Icon" className="w-9 h-9" />,
          style: {
            borderRadius: '10px',
            background: '#FFFAA0',
            color: 'black',
          },
        });
      }
    }

    setFormData({ ...formData, recordCount: count, job_format: jobtypeprocess(formData) });
  };




const addjobtodb = async () => {
    const status = 1;
    const info = {
      company: company,
      permitHolder: formData?.permitId,
      mailOwner: formData?.ownerId,
      mailProvider: formData?.providerId,
      product: formData?.productId,
      mailDate: formData?.mailDate,
      mailClass: formData?.mailClass,
      postOfficeEntry: formData?.permitBmeu,
      jobDescription: formData?.jobDescription,
      currentStatus: status,
      recordCount: formData?.recordCount,
      basepromotions: formData?.basepromotions,
      dropship: formData?.dropship,
      dropshipname: formData?.dropshipname,
      ballotbox: formData?.ballotbox,
      addon1: formData?.addon1,
      addon2: formData?.addon2,
      job_format: formData?.job_format,
      machinable: formData?.machinable,
      no1Trays: formData?.no1Trays,
      growthIncentive: formData?.growthIncentive,
      political: formData?.political,
      uspsJobId: formData?.uspsJobId,
      IMbarcode: formData?.IMbarcode,
      unevenThickness: formData?.unevenThickness
    };

    try {
      console.log('Adding job to DB:', info);
      const res = await axios.post(`${apiUrl}/jobs/addjobtodb`, info);
      if (res.data.status === 200) {
        console.log(res.data)
        const formDataToSend = new FormData();
        if (jsonData) {
          // Add jobId to the JSON data
          const updatedJsonData = JSON.stringify({
            ...JSON.parse(jsonData),
            jobId: res.data?.message?.jobId // Assuming jobId is in res.data
          });
          const blob = new Blob([updatedJsonData], { type: 'application/json' });
          const jsonFile = new File([blob], 'user-data.json', { type: 'application/json' });
          formDataToSend.append('jsonFile', jsonFile);
          formDataToSend.append('recipient', 'summanusb@gmail.com,bryan@plsprint.com');
          formDataToSend.append('company', user.company?.name || 'Unknown');
          formDataToSend.append('jobDescription', String(formData?.jobDescription));
        }
        // Add CSV files
        if (Object.keys(finalCSVs).length > 0) {
          Object.entries(finalCSVs).forEach(([fileName, csvData]) => {
            const csvBlob = new Blob([csvData], { type: 'text/csv' });
            const csvFile = new File([csvBlob], `${fileName}.csv`, { type: 'text/csv' });
            formDataToSend.append('csvFiles', csvFile);
            console.log(`CSV File added in addjobtodb: ${fileName}.csv`);
          });
        }
        await sendjob(formDataToSend);
      }
    } catch (err) {
      console.error('Error in addjobtodb:', err.response?.data || err.message);
      setError(err.response?.data?.error || err.message);
      toast.error('Failed to add job to database: ' + (err.response?.data?.error || err.message));
    }
};

  // const addjobtodb = async () => {
  //   const status =  1;
  //   const info = {
  //     company:company,
  //     permitHolder: formData?.permitId,
  //     mailOwner: formData?.ownerId,
  //     mailProvider: formData?.providerId,
  //     product: formData?.productId,
  //     mailDate: formData?.mailDate,
  //     mailClass: formData?.mailClass,
  //     postOfficeEntry: formData?.permitBmeu,
  //     jobDescription: formData?.jobDescription,
  //     currentStatus: status,
  //     recordCount: formData?.recordCount,
  //     basepromotions:formData?.basepromotions,
  //     dropship:formData?.dropship,
  //     dropshipname:formData?.dropshipname,
  //     ballotbox:formData?.ballotbox,
  //     addon1:formData?.addon1,
  //     addon2:formData?.addon2,
  //     job_format:formData?.job_format,
  //     machinable:formData?.machinable,
  //     no1Trays:formData?.no1Trays,
  //     growthIncentive:formData?.growthIncentive,
  //     political:formData?.political,
  //     uspsJobId:formData?.uspsJobId,
  //     IMbarcode:formData?.IMbarcode,
  //     unevenThickness:formData?.unevenThickness
  //   };

  //   try {
  //     console.log('Adding job to DB:', info);
  //     const res = await axios.post(`${apiUrl}/jobs/addjobtodb`, info);
  //     if (res.data.status === 200) {
  //       const formDataToSend = new FormData();
  //       if (jsonData) {
  //         const blob = new Blob([jsonData], { type: 'application/json' });
  //         const jsonFile = new File([blob], 'user-data.json', { type: 'application/json' });
  //         formDataToSend.append('jsonFile', jsonFile);
  //         formDataToSend.append('recipient', 'summanusb@gmail.com');
  //         formDataToSend.append('company', user.company?.name || 'Unknown');
  //         formDataToSend.append('jobDescription', String(formData?.jobDescription));
  //       }
  //       // Add CSV files
  //       if (Object.keys(finalCSVs).length > 0) {
  //         Object.entries(finalCSVs).forEach(([fileName, csvData]) => {
  //           const csvBlob = new Blob([csvData], { type: 'text/csv' });
  //           const csvFile = new File([csvBlob], `${fileName}.csv`, { type: 'text/csv' });
  //           formDataToSend.append('csvFiles', csvFile);
  //           console.log(`CSV File added in addjobtodb: ${fileName}.csv`);
  //         });
  //       }
  //       await sendjob(formDataToSend);
  //     }
  //   } catch (err) {
  //     console.error('Error in addjobtodb:', err.response?.data || err.message);
  //     setError(err.response?.data?.error || err.message);
  //     toast.error('Failed to add job to database: ' + (err.response?.data?.error || err.message));
  //   }
  // };

  const checkeverything = async () => {

    if (!jsonData) {
      toast.error('JSON file is missing', {
        icon: <img src={JSONIMG} alt="JSON Icon" className="w-9 h-9" />,
        style: {
          borderRadius: '10px',
          background: 'yellow',
          color: 'black',
        },
      });
      return;
    }
    if (Object.keys(finalCSVs).length === 0) {
      toast.error('CSV file is missing', {
        icon: <img src={CSVIMG} alt="CSV Icon" className="w-9 h-9" />,
        style: {
          borderRadius: '10px',
          background: '#FFFAA0',
          color: 'black',
        },
      });
      return;
    }
    await addjobtodb();
  };

  const sendjob = async (formDataToSend) => {
    try {
      await toast.promise(
        axios.post(`${apiUrl}/jobs/email`, formDataToSend, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }),
        {
          loading: 'Loading',
          success: 'Job Successfully Submitted',
          error: 'Error when fetching',
        }
      );
      setJsonData(null);
      setFormData({});
      setFinalCSVs({});
      nav(`/dashboard/customer/${company._id}`);
    } catch (error) {
      console.error('Error sending email:', error.response?.data || error.message);
      setError(error.response?.data?.error || error.message);
      toast.error('Failed to email data: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleClick = ({company}) => {
    toast((t) => (
      <div className="flex flex-col items-center gap-4 p-6 bg-white rounded-lg shadow-xl border border-gray-100 transform transition-all duration-300 ease-in-out">
        <span className="text-gray-800 font-medium text-lg">
          Are you sure you want to proceed?
        </span>
        <div className="flex gap-3">
          <button
            type="button"
            className="px-5 py-2 bg-indigo-600 text-white rounded-full font-semibold text-sm hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-200 ease-in-out transform hover:scale-105"
            onClick={() => {
              handleConfirmedAction(company);
              toast.dismiss(t.id);
            }}
          >
            Yes
          </button>
          <button
            type="button"
            className="px-5 py-2 bg-gray-200 text-gray-800 rounded-full font-semibold text-sm hover:bg-gray-300 focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-all duration-200 ease-in-out transform hover:scale-105"
            onClick={() => {
              toast.dismiss(t.id);
            }}
          >
            No
          </button>
        </div>
      </div>
    ), {
      duration: Infinity,
      style: {
        background: 'transparent',
        boxShadow: 'none',
        padding: 0,
      },
    });
  };

  const value = {
    formData,
    setFormData,
    getjson,
    finalCSVs,
    setFinalCSVs,
    sendum,
    sendjob,
    addjobtodb,
    checkeverything,
    handleClick,
    setCompany,
    company
  };

  return <JobContext.Provider value={value}>{children}</JobContext.Provider>;
};

export const useJobContext = () => useContext(JobContext);


